import { render } from "./UpdateOpenTrip.vue?vue&type=template&id=378f4f3a&scoped=true"
import script from "./UpdateOpenTrip.vue?vue&type=script&lang=js"
export * from "./UpdateOpenTrip.vue?vue&type=script&lang=js"

import "./UpdateOpenTrip.vue?vue&type=style&index=0&id=378f4f3a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378f4f3a"]])

export default __exports__